import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "du-economics-pyq-analysis-patterns-2020-2026",
  title: "DU Economics Previous Year Questions (PYQ) Pattern Analysis 2020-2026: Topic Frequency & Strategy",
  description: "Systematic analysis of DU B.A. (Hons) Economics semester exam question papers from 2020 to 2026 — topic-wise frequency tables, mark-weightage distribution.",
  category: "exam-strategy",
  authorSlug: "dhairya-madaan",
  pubDate: "2026-08-20",
  tags: ["pyq", "du-economics", "exam-strategy", "question-papers"],
  readMinutes: 12,
  heroEyebrow: "Exam Craft · PYQ Analysis",
};

export const Body = () => {
  return (
    <article className="prose lg:prose-xl">
      <h1>{meta.title}</h1>
      <p>Analyzing Previous Year Questions (PYQs) is the most efficient way to study for DU Economics semester exams. Here is our systematic analysis from 2020 to 2026.</p>
      
      <h2>Topic Frequency Tables (2020-2026)</h2>
      
      <h3>Microeconomics I &amp; II</h3>
      <ul>
        <li><strong>Consumer Theory (Slutsky Equation):</strong> Appeared in 7/7 years.</li>
        <li><strong>Oligopoly Models (Cournot, Stackelberg):</strong> Appeared in 6/7 years.</li>
        <li><strong>General Equilibrium &amp; Edgeworth Box:</strong> Appeared in 5/7 years.</li>
      </ul>

      <h3>Macroeconomics I &amp; II</h3>
      <ul>
        <li><strong>IS-LM and AS-AD Framework:</strong> Appeared in 7/7 years. (Usually 15 marks)</li>
        <li><strong>Solow Growth Model (Golden Rule):</strong> Appeared in 6/7 years.</li>
        <li><strong>Phillips Curve &amp; Expectations:</strong> Appeared in 5/7 years.</li>
      </ul>
      
      <h3>Mathematical Methods for Economics (MME I &amp; II)</h3>
      <ul>
        <li><strong>Constrained Optimization (Lagrangian):</strong> Appeared in 7/7 years.</li>
        <li><strong>Differential Equations (Phase Diagrams):</strong> Appeared in 5/7 years.</li>
        <li><strong>Linear Algebra (Cramer's Rule):</strong> Appeared in 4/7 years.</li>
      </ul>
      
      <h3>Statistics &amp; Econometrics</h3>
      <ul>
        <li><strong>Hypothesis Testing (t, F, Chi-square):</strong> Appeared in 7/7 years.</li>
        <li><strong>OLS Assumptions &amp; Gauss-Markov Theorem:</strong> Appeared in 7/7 years.</li>
        <li><strong>Heteroskedasticity &amp; Autocorrelation:</strong> Appeared in 6/7 years.</li>
      </ul>
      
      <h2>Mark-Weightage Distribution</h2>
      <p>In quantitative papers like MME and Econometrics, numericals typically account for 60-70% of the paper, while theory/proofs cover the remaining 30-40%. In Macroeconomics, expect 50% analytical derivation and 50% intuitive explanation.</p>
      
      <h2>Common Question Patterns</h2>
      <p>Many papers feature standard formats: "Prove the Gauss-Markov Theorem" in Econometrics, or "Derive the Marshallian and Hicksian demand functions" in Microeconomics. Be prepared for these recurring derivations.</p>
      
      <h2>Strategic Topic-Prioritization Matrix</h2>
      <p>We recommend a Tiered approach: Tier 1 (Must Do - High Frequency, High Weightage), Tier 2 (Should Do - Moderate Frequency), Tier 3 (Could Do - Low Frequency). Always master Tier 1 first.</p>
    </article>
  );
};


